module.exports = __webpack_public_path__ + "img/4.c056d9fe.png";